import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { isNullOrUndefined } from '@pineapplelab/util';
import { PipesModule } from '../../pipes/pipes.module';

export interface ChangeQuizPercentageData {
	categoryName: string;
	passPercentage: number | null;
}

@Component({
	selector: 'app-change-quiz-percentage-popup',
	standalone: true,
	imports: [
		CommonModule,
		FormsModule,
		MatDialogModule,
		MatFormFieldModule,
		MatInputModule,
		MatButtonModule,
		MatIconModule,
		PipesModule
	],
	templateUrl: './change-quiz-percentage-popup.component.html',
	styleUrl: './change-quiz-percentage-popup.component.scss'
})
export class ChangeQuizPercentagePopupComponent {

	percentage: number | null = null;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: ChangeQuizPercentageData,
		private dialogRef: MatDialogRef<ChangeQuizPercentagePopupComponent>
	) {
		this.percentage = isNullOrUndefined(this.data?.passPercentage) ? null : this.data.passPercentage;
	}

	get isValid(): boolean {
		// Empty clears the override; otherwise it must be an integer between 0 and 100.
		if (isNullOrUndefined(this.percentage)) {
			return true;
		}
		return this.percentage >= 0 && this.percentage <= 100;
	}

	dismiss(): void {
		this.dialogRef.close();
	}

	save(): void {
		if (!this.isValid) {
			return;
		}
		const value = isNullOrUndefined(this.percentage) ? null : Number(this.percentage);
		this.dialogRef.close({ passPercentage: value });
	}
}
